import { render } from "./VideoDetailsCategorySubContents.vue?vue&type=template&id=dee6de44&ts=true"
import script from "./VideoDetailsCategorySubContents.vue?vue&type=script&lang=ts"
export * from "./VideoDetailsCategorySubContents.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__